import { useEffect } from 'react';
import { Button, Card, FormattedMessageDiv, useWizardContext } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getLDR, getLDROpts } from 'merchant-api/spiceroad';
import { useApplication } from 'merchant-api/unified';
import { loanStep } from '../helpers';

const BANK_REQUEST_GRACE_POLL_MS = 3_000;
const BANK_REQUEST_GRACE_POLLS = 5;

export function ReceivedCard() {
  const navigate = useNavigate();
  const { applicationData } = useApplication();
  const { step } = loanStep();
  const { hasBankRequest, query: ldrQuery } = getLDR();
  const { goToStep } = useWizardContext();

  // A just-decisioned application lands here when its bank request has not been OPENED yet: the
  // request is created asynchronously (SF automation) and nothing tells the client whether bank
  // documents will be requested at all. Re-check for a bounded grace window - if a request opens,
  // the mapper flips to the bank step and we follow it; if none appears, this application needs
  // no documents and this screen is final. The poll expires on its own (dataUpdateCount), so
  // no-documents applications simply stay here.
  const opportunityId = applicationData?.metadata?.sfOpportunityId;
  const bankRequestMayStillOpen =
    ['APPROVED', 'PREPROCESSED'].includes(applicationData?.status ?? '') && ldrQuery.status === 'success' && !hasBankRequest;
  useQuery({
    ...getLDROpts(opportunityId ?? ''),
    enabled: bankRequestMayStillOpen && !!opportunityId,
    refetchInterval: (query) => (query.state.dataUpdateCount > BANK_REQUEST_GRACE_POLLS ? false : BANK_REQUEST_GRACE_POLL_MS),
  });

  useEffect(() => {
    if (step === 'BANK_INFO' || step === 'BANK_CONFIRMATION') goToStep(step);
  }, [step, goToStep]);

  return (
    <Stack gap={6} style={{maxWidth: '600px', margin: 'auto'}}>
      <FormattedMessageDiv className="h3 text-center mb-0" id="application.softDecline.title" />
      <Card bodyClassName="px-md-8">
        <Stack gap={0}>
          <FormattedMessageDiv
            id={'application.softDecline.subtitle'}
            className="h4 mb-4"
            />
          <FormattedMessageDiv className="mb-4" id="application.softDecline.msg"/>
            <div>
              <FormattedMessageDiv className="mb-0" id="application.softDecline.description" />
              <ul className="mb-0">
                {Array.from({ length: 3 }).map((_, i) => (
                  <li key={i}>
                    <FormattedMessageDiv className="d-inline" id={`application.softDecline.description.list.item${i + 1}`} />
                  </li>
                ))}
              </ul>
            </div>
          {
            applicationData?.type === 'RENEWAL' && (
              <div className="d-flex justify-content-center mt-5">
                <Button onClick={() => navigate({to: '/'})}>
                <FormattedMessageDiv id="btn.returnToDashboard" />
                </Button>
              </div>
            )
          }
        </Stack>
      </Card>
    </Stack>

  );
}

export default ReceivedCard;
